/** Nombres de muestra para chips / preview / arrastre a email. */
export function meetingLinkedSampleNames(link) {
  const cliente = String(link?.muestraNombreCliente || "").trim();
  const samp = String(link?.muestraNombre || "").trim();
  const id = Number(link?.idMuestra);
  const fallback = Number.isInteger(id) && id > 0 ? `#${id}` : "";
  return {
    cliente,
    samp,
    fallback,
  };
}

/** Chip de muestra: NombreCliente, si no el SAMP. */
export function meetingLinkedSampleChipLabel(link) {
  const { cliente, samp, fallback } = meetingLinkedSampleNames(link);
  return cliente || samp || fallback;
}

export function meetingLinkedSampleHintName(link) {
  const { cliente, samp, fallback } = meetingLinkedSampleNames(link);
  if (cliente && samp && cliente !== samp) return `${cliente} · ${samp}`;
  return cliente || samp || fallback;
}

export function sanitizeMeetingFileStem(name) {
  const cleaned = String(name || "")
    .replace(/[<>:"/\\|?*]/g, " ")
    .split("")
    .map((ch) => (ch.charCodeAt(0) < 32 ? " " : ch))
    .join("")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 80);
  return cleaned || "foto";
}

export function meetingPhotoLinkedSample(photo) {
  if (!photo) return null;
  if (Array.isArray(photo.linkedMuestras) && photo.linkedMuestras.length) {
    return photo.linkedMuestras[photo.linkedMuestras.length - 1];
  }
  if (photo.idMuestra || photo.muestraNombre || photo.muestraNombreCliente) {
    return {
      idMuestra: photo.idMuestra,
      muestraNombre: photo.muestraNombre || "",
      muestraNombreCliente: photo.muestraNombreCliente || "",
    };
  }
  return null;
}

/** True si la pieza ya tiene muestra vinculada (no se puede volver a linkar). */
export function meetingPhotoIsLinked(photo) {
  if (!photo) return false;
  if (Array.isArray(photo.linkedMuestras) && photo.linkedMuestras.length) {
    return true;
  }
  const id = Number(photo.idMuestra);
  return Number.isInteger(id) && id > 0;
}

export function meetingPhotoFileStem(photo) {
  const link = meetingPhotoLinkedSample(photo);
  const { cliente, samp, fallback } = meetingLinkedSampleNames(link || {});
  return sanitizeMeetingFileStem(
    cliente || samp || fallback || `foto-${photo?.id || "reunion"}`,
  );
}

export function meetingPhotoDownloadName(photo, mimeType) {
  const stem = meetingPhotoFileStem(photo);
  const mime = String(
    mimeType || photo?.mimeType || "image/jpeg",
  ).toLowerCase();
  let ext = ".jpg";
  if (mime.includes("png")) ext = ".png";
  else if (mime.includes("webp")) ext = ".webp";
  else if (mime.includes("gif")) ext = ".gif";
  else if (mime.includes("jpeg") || mime.includes("jpg")) ext = ".jpg";
  else {
    const fromUrl = String(photo?.fileUrl || photo?.displayFileUrl || "")
      .toLowerCase()
      .match(/\.(jpe?g|png|webp|gif)(?:\?|$)/);
    if (fromUrl?.[1]) ext = `.${fromUrl[1].replace("jpeg", "jpg")}`;
  }
  return `${stem}${ext}`;
}

/** File con el nombre de muestra cliente; Outlook ignora el nombre si no coincide. */
export function fileWithMeetingPhotoName(photo, source) {
  if (!source) return null;
  const name = meetingPhotoDownloadName(photo, source.type).replace(/:/g, "-");
  if (source.name === name) return source;
  return new File([source], name, {
    type: source.type || "image/jpeg",
    lastModified: source.lastModified || Date.now(),
  });
}
